//Custom JS for ATI by Ben Skigen ben@skigendigital.com
console.log("12-9-24 atiCustomizations running on template ", collectionSuffix)
const productGrid = document.querySelectorAll(".collection__cards");
// Loop through each element in the NodeList and set the style
productGrid.forEach(function (element) {
    element.style.display = "none";
});

//ati collection filtering customization
function limitDisplayedFilters() {
    console.log("limitDisplayedFilters");
    // Limit the number of displayed filters. Adds "show more" link which enables display of all filters.
    //set the limit
    document.querySelectorAll("ul.collection-sidebar__items").forEach(function (ul) {
        //if this is optic brand, limit to five options.
        let previousElement = ul.parentElement.previousElementSibling;
        let previousElementText = previousElement ? previousElement.textContent.trim() : null;
        let limit = (previousElementText === "Optic Brand") ? 5 : 99;
        if (ul.querySelectorAll("li").length > limit) {
            const hiddenOptions = document.createElement('div');
            hiddenOptions.className = 'hideOptions';
            hiddenOptions.style.display = 'none';
            const showMoreLink = document.createElement('span');
            showMoreLink.className = 'showHiddenOptions';
            showMoreLink.textContent = 'SHOW ALL';
            showMoreLink.addEventListener('click', function () {
                hiddenOptions.style.display = '';
                this.style.display = 'none';
            });
            const listItems = Array.from(ul.querySelectorAll("li")).slice(limit);
            listItems.forEach(function (li) {
                hiddenOptions.appendChild(li);
            });
            ul.appendChild(hiddenOptions);
            ul.appendChild(showMoreLink);
        }
    });
}

function reactToFilterState() {
    // console.log("reactToFilterState");
    // Get the state of all filter groups to see if anything is checked
    let optic_brand = 0, optic_model = 0, optic_magnification = 0, accessory_type = 0, optic_side = 0, color = 0,
        optionClass = "";
    document.querySelectorAll(".collection-sidebar__filter details").forEach(function (details) {
        if (details.querySelectorAll("ul.collection-sidebar__items input:checked").length > 0) {
            optionClass = details.className;
            if (optionClass.indexOf("optic-brand") > 0) { optic_brand = 1; }
            if (optionClass.indexOf("optic-model") > 0) { optic_model = 1; }
            if (optionClass.indexOf("optic-magnification") > 0) { optic_magnification = 1; }
            if (optionClass.indexOf("optic-side") > 0) { optic_side = 1; }
            if (optionClass.indexOf("product-type") > 0) { accessory_type = 1; }
            if (optionClass.indexOf("color") > 0) { color = 1; }
            const checkedInputs = details.querySelectorAll("ul.collection-sidebar__items input:checked")
            const labels = [];
            checkedInputs.forEach(input => {
                const label = input.nextElementSibling;
                if (label && label.tagName === 'LABEL') {
                    labels.push(label.innerText.trim().replace(/\d+$/, ""));
                }
            });
            const optionTitle = details.querySelector("summary span")
        }
    });

    function expandFilter(filterClass) {
        console.log("expandFilter: ", filterClass);
        const filterTrigger = document.querySelector("." + filterClass + " .collection-sidebar__filter-trigger");
        // Check if the element does not have the 'open' attribute
        if (filterTrigger && !filterTrigger.hasAttribute('open')) {
            console.log("expandFilter not open, expanding ", filterClass);
            filterTrigger.click();  // Click the element if it doesn't have the 'open' attribute
        }
    }

    function hideFilter(filterClass) {
        console.log("hideFilter: ", filterClass)
        const element = document.querySelector("." + filterClass);
        //if matching element exists
        if (element) {
            element.style.display = 'none';
        }
    }

    function showFilter(filterClass) {
        console.log("showFilter: ", filterClass)
        const element = document.querySelector("." + filterClass);
        if (element) {
            element.style.display = '';
        }
    }

//always show product-type & brand

    if ((window.location.pathname) === "/collections/all") {
        console.log("on /collections/all");
        expandFilter("brand");
        hideFilter("collection-sidebar__filter-group.optic-magnification");
        hideFilter("collection-sidebar__filter-group.optic-model");
        hideFilter("collection-sidebar__filter-group.optic-side");
        hideFilter("collection-sidebar__filter-group.color");
        expandFilter("product-type");
        expandFilter("optic-brand");
    } else if ((window.location.href).includes('-riflescopes')) {
        hideFilter("collection-sidebar__filter-group.brand")
        hideFilter("collection-sidebar__filter-group.optic-brand")
        hideFilter("collection-sidebar__filter-group.optic-model");
        expandFilter("product-type");
    }

    //on a tenabraex accessory page that is not tenabraex-riflescope-accessories
    else if (collectionSuffix === "tb-accy-filters" && !(window.location.href).includes('tenebraex-riflescope-accessories')) {
        hideFilter("product-type")
        expandFilter("optic-brand");
        hideFilter("brand")

    }

    else {
        console.log("not on /collections/all");
        hideFilter("collection-sidebar__filter-group.brand")
        expandFilter("product-type");
        expandFilter("optic-brand");
    }
    //ati-accy-filters
    if (collectionSuffix.includes("tb-accy-filters")) {
        console.log("running filter customizations for template tb-accy-filters")
        console.log("debug: optic_brand:", optic_brand, " optic_model:", optic_model, " optic_magnification:",
            optic_magnification, " optic_side:", optic_side, " accessory_type:", accessory_type, " color:", color);
        // optic_brand, optic_model, and optic_magnification are not selected
        if (!optic_brand && !optic_model && !optic_magnification) {
            console.log("!optic_brand && !optic_model && !optic_magnification")
            // Expand opticBrand and accessory type
            expandFilter("optic-brand");
            expandFilter("product-type");
            hideFilter("optic-model");
            hideFilter("optic-side");
            hideFilter("color");
            hideFilter("collection-sidebar__filter-group--price");
            hideFilter("optic-magnification");
        } else if (optic_brand && !optic_model && !optic_magnification) {
            console.log("optic_brand && !optic_model && !optic_magnification")
            showFilter("optic-model")
            expandFilter("optic-brand");
            expandFilter("product-type");
            expandFilter("optic-model");
            hideFilter("optic-magnification");
        } else if (optic_brand && optic_model && !optic_magnification) {
            console.log("optic_brand && optic_model && !optic_magnification")
            showFilter("optic-magnification");
            expandFilter("optic-brand");
            expandFilter("product-type");
            expandFilter("optic-magnification");
            expandFilter("optic-side");
            expandFilter("color");
        } else if (optic_brand && optic_model && optic_magnification) {
            console.log("optic_brand && optic_model && optic_magnification")
            showFilter("optic-side");
            expandFilter("optic-brand");
            expandFilter("product-type");
            expandFilter("optic-side");
            expandFilter("color");
        }

        if (collectionSuffix.includes("tb-accy-filters-brand")) {
            //redirect to main page if brand list is closed.
            if (!window.location.href.includes("tenebraex-riflescope-accessories")) {
                const mainSection = "/collections/tenebraex-riflescope-accessories"
                document.querySelector("details.optic-brand summary-icon").addEventListener('click', function (e) {
                    e.stopImmediatePropagation();
                    window.location.href = mainSection;
                });
                document.querySelector("label[for='Filter-Optic Brand-1']").addEventListener('click', function (e) {
                    e.stopImmediatePropagation();
                    window.location.href = mainSection;
                });
                //if the clear all filters pill is clicked, redirect to main section
                document.querySelector("a.collection__filters-active__filter--clear").addEventListener('click', function (e) {
                    e.stopImmediatePropagation();
                    window.location.href = mainSection;
                });
                //if one of the pills is clicked and it doesn't have the parameter 'global.optic_brand', that means the
                // user wishes to clear the optic brand, so redirect back to main section
                document.querySelectorAll('.collection__filters-active__filter').forEach(link => {
                    link.addEventListener('click', function (e) {
                        const url = new URL(link.href);  // Get the URL of the clicked link
                        if (!url.searchParams.has('filter.p.m.global.optic_brand')) {
                            e.stopImmediatePropagation();
                            window.location.href = mainSection;
                        }
                    });
                });
            }
        }
    }
}

function openBrandPageForBrandOptionClicks() {
    function findRedirect(input) {
        const manualRedirects = [
            "tenebræx|tenebraex-riflescope-accessories",
            "elcan|elcan-specter-riflescopes",
            "sai optics|sai-optics-riflescopes",
            "tangent theta|tangent-theta-riflescopes",
            "xoptek|sai-optics-xoptek",
        ];
        const match = manualRedirects.find(item => item.split('|')[0] === input);
        // If a match is found, return the part after the pipe
        if (match) {
            return match.split('|')[1];
        } else {
            return null; // Return null if no match is found
        }
    }

    $(".optic-brand li label,.brand li label").on("click", function (e) {
        e.preventDefault();
        params = (window.location.href);
        var brandValue = $(this).prev("input").val();
        let param = '';
        if ($("input[name='filter.p.m.global.product_group']:checked").length > 0) {
            param = '?filter.p.m.global.product_group=' + $("input[name='filter.p.m.global.product_group']:checked").first().val().replace(/\s/g, "+")
        }
        // console.log(param)
        let brandHandle = (findRedirect(brandValue.toLowerCase()) != null && (window.location.href).includes("collections/all")) ? findRedirect(brandValue.toLowerCase()) : brandValue.toLowerCase().replace(/[^a-z0-9\s-]/g, '').replace(/\s+/g, '-').replace(/-+/g, '-').replace(/^-+|-+$/g, '');
        // console.log(params, brandHandle)
        window.location = (window.location.href).replace(/[^\/]+(?=\/?$|\?)/, brandHandle + param)
    });
}




function atiCustomFiltering() {
    console.log("collectionSuffix",collectionSuffix)
    limitDisplayedFilters();
    reactToFilterState();
    //if on tenabraex main page, redirect to brand page (to overcome option limits on filtering app)
   if ((window.location.href).includes("tenebraex-riflescope-accessories")) { 
        console.log("on " + window.location.pathname + ", adding brand redirect function  ")
        openBrandPageForBrandOptionClicks();
    } else {
        console.log(" not on path with brand redirection, skipping brand redirect function  ")
    }
}

window.addEventListener('DOMContentLoaded', function () {
    atiCustomFiltering();

    if (collectionSuffix.includes("tb-accy-filters-brand")) {
        console.log("running customizations for template tb-accy-filters-brand")
        document.querySelectorAll('ul.collection-sidebar__items').forEach(ul => {
            // Check if the parent of the parent of the ul doesn't have the class 'brand'
            if (ul.parentElement.parentElement.classList.contains('optic-brand')) {
                const liElements = ul.querySelectorAll('li');  // Get all li elements inside the ul
                if (liElements.length === 1) {
                    const checkbox = liElements[0].querySelector('input[type="checkbox"]');  // Get the checkbox inside
                                                                                             // the li
                    if (checkbox && !checkbox.checked) {  // Check if the checkbox is not checked
                        checkbox.click();  // Click the checkbox if it's not checked
                    }
                }
            }
        });
        
        const params = new URLSearchParams(window.location.search);
        if (params.get("showFilters") === "true") {
          openFilters();
        }
        
       


    }


    productGrid.forEach(function (element) {
        element.style.display = "";
    });
});


function openFilters(){
$(".collection-main__filter-btn ").click()
}